import "./OpenRound.css";
import { Link } from "react-router-dom";
import StarRoundIcon from '@mui/icons-material/Star';

const OpenRound = ({ img, header, text, link }) => {
  return (
    <div className="openRound">
      <div className="imgAndText">
        <img className="openRoundImg" src={img} />
        <div className="openRoundText">
          <div className="openRoundTextH">{header}</div>
          <div className="openRoundTextP">{text}</div>
          <div className="starSection">
            <StarRoundIcon className="starImg" />
            <div>5.0 (1435 ביקורות)</div>
          </div>
        </div>
      </div>
      <div className="doctorsbtn">
        <Link className="about" to={"/doctor"}>
          אודות
        </Link>
        <Link className="appointment" to={"/appointment"}>
          פגישה
        </Link>
      </div>
    </div>
  );
};

export default OpenRound;
